var S;
!function (S) {
  S.XS = "XS", S.S = "S", S.M = "M", S.L = "L";
}(S || (S = {}));
export { S as B };
